import { Reveal, SectionLabel } from "./Reveal";

const CREDITS = ["Luciano", "Kumar (Raging Fyah)", "Mikey General", "Warrior King"];

const PRODUCERS = [
  {
    id: "reverbero",
    name: "Reverbero",
    role: "Production",
    text: "A keyboardist for Italian bands such as Working Vibes and EBM, with experience throughout Europe and as a backing band for Rita Marley during her Italian tours.",
  },
  {
    id: "chisco",
    name: "Chisco",
    role: "Production",
    text: "Lead singer of Working Vibes and a solo artist with seven albums to his credit, has collaborated with Dennis Bovell and Sud Sound System.",
  },
];

export function Bio() {
  return (
    <section id="bio" data-testid="bio-section" className="relative mx-auto max-w-[1440px] px-5 py-28 md:px-10 md:py-40">
      <Reveal><SectionLabel index="01">Bio</SectionLabel></Reveal>
      <div className="mt-12 grid gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.9] sm:text-6xl lg:text-7xl">
            Producers &amp; soundboys <span className="font-serif-i font-normal normal-case text-[var(--gold)]">for over</span> twenty years.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-4 lg:col-start-9 lg:pt-4">
          <p className="text-base leading-relaxed text-[var(--stone)]">
            With a track record of producing for reggae stars such as Luciano, Kumar (Raging Fyah), Mikey General, and Warrior King, StillWorking aims to produce and arrange reggae riddims to spark a new wave in the spirit of Jamaican classics.
          </p>
          <ul className="mt-8 flex flex-wrap gap-2" data-testid="bio-credits">
            {CREDITS.map((c) => (
              <li key={c} className="rounded-full border border-[var(--gold)]/40 px-3 py-1 font-mono text-xs uppercase tracking-[0.15em] text-[var(--bone)]">{c}</li>
            ))}
          </ul>
        </Reveal>
      </div>
      <div className="mt-16 grid gap-10 md:grid-cols-2 md:gap-16" data-testid="bio-producers">
        {PRODUCERS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.1} data-testid={`bio-producer-${p.id}-card`}>
            <div className="border-t-2 border-[var(--gold)] pt-6">
              <div className="flex items-baseline justify-between gap-4">
                <h3 className="font-display text-4xl font-extrabold uppercase md:text-5xl">{p.name}</h3>
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--gold)]">{p.role}</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-[var(--stone)] md:text-base">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
